import { useId } from 'react';

import type { ChkIconProps } from './ChkIcon.types';
import { ChkSvgWrapper } from './ChkIcon.utils';

export const ChkIconLoader = ({ color, ...rest }: ChkIconProps) => {
  const spinnerId = useId();

  return (
    <ChkSvgWrapper
      viewBox="0 0 100 100"
      overflow="visible"
      fill={color ?? 'currentColor'}
      stroke="none"
      {...rest}
    >
      <defs>
        <rect
          id={spinnerId}
          x="46.5"
          y="45"
          width="6"
          height="14"
          rx="2"
          ry="2"
          transform="translate(0 -30)"
        />
      </defs>
      <use
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xlinkHref={`#${spinnerId}`}
        transform="rotate(0 50 50)"
      >
        <animate
          attributeName="opacity"
          values="0;1;0"
          dur="2s"
          begin="0s"
          repeatCount="indefinite"
        />{' '}
      </use>
      <use
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xlinkHref={`#${spinnerId}`}
        transform="rotate(45 50 50)"
      >
        <animate
          attributeName="opacity"
          values="0;1;0"
          dur="2s"
          begin="0.25s"
          repeatCount="indefinite"
        />{' '}
      </use>
      <use
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xlinkHref={`#${spinnerId}`}
        transform="rotate(90 50 50)"
      >
        <animate
          attributeName="opacity"
          values="0;1;0"
          dur="2s"
          begin="0.5s"
          repeatCount="indefinite"
        />{' '}
      </use>
      <use
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xlinkHref={`#${spinnerId}`}
        transform="rotate(135 50 50)"
      >
        <animate
          attributeName="opacity"
          values="0;1;0"
          dur="2s"
          begin="0.75s"
          repeatCount="indefinite"
        />{' '}
      </use>
      <use
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xlinkHref={`#${spinnerId}`}
        transform="rotate(180 50 50)"
      >
        <animate
          attributeName="opacity"
          values="0;1;0"
          dur="2s"
          begin="1s"
          repeatCount="indefinite"
        />{' '}
      </use>
      <use
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xlinkHref={`#${spinnerId}`}
        transform="rotate(225 50 50)"
      >
        <animate
          attributeName="opacity"
          values="0;1;0"
          dur="2s"
          begin="1.25s"
          repeatCount="indefinite"
        />{' '}
      </use>
      <use
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xlinkHref={`#${spinnerId}`}
        transform="rotate(270 50 50)"
      >
        <animate
          attributeName="opacity"
          values="0;1;0"
          dur="2s"
          begin="1.5s"
          repeatCount="indefinite"
        />{' '}
      </use>
      <use
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xlinkHref={`#${spinnerId}`}
        transform="rotate(315 50 50)"
      >
        <animate
          attributeName="opacity"
          values="0;1;0"
          dur="2s"
          begin="1.75s"
          repeatCount="indefinite"
        />{' '}
      </use>{' '}
    </ChkSvgWrapper>
  );
};
